var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Title',{attrs:{"title":"各種設定","description":"パスワードの変更ができます。"}}),[_c('ConfigAdmin',{on:{"update":function($event){return _vm.update()}}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }